document.addEventListener("DOMContentLoaded", function () {
  var skipButton = document.getElementById("skipButton");
  var goBackButton = document.getElementById("goBackButton");
  var progressBar = document.querySelector(".cart-progress");
  var giftSelector = document.getElementById("giftSelectorSection");
  var greetingMessage = document.getElementById("greetingMessageSection");
  var calendarSection = document.getElementById("calendarSection");

  var sections = [greetingMessage, giftSelector, calendarSection];
  var steps = document.querySelectorAll(".progress-bar .step");

  var totalSteps = sections.length - 1;

  // ✅ Event listener for external cart step updates
  document.addEventListener("cartStepChangedExternally", (e) => {
    const newStep = e.detail?.newStep;
    if (typeof newStep === "number") {
      updateUI(newStep);
    }
  });

  steps.forEach((step, index) => {
    step.addEventListener("click", () => {
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          const currentStep = parseInt(cart.attributes?.current_step || "0");
          if (index <= currentStep + 1) {
            changeStep(index);
          }
        });
    });
  });

  function updateUI(step) {
    console.log("Updating UI to step:", step);
    sections.forEach((section, index) => {
      if (section) {
        section.style.display = index === step ? "block" : "none";
      }
    });
    updateProgressBar(step);
    updateButtonStates(step);
  }

  function updateProgressBar(stepIndex) {
    steps.forEach((step, index) => {
      step.classList.toggle("active", index <= stepIndex);
    });
  }

  function updateButtonStates(step) {
    goBackButton.disabled = step === 0;
    goBackButton.classList.toggle("active", step > 0);

    skipButton.disabled = step >= totalSteps;

    skipButton.classList.remove("filled", "disabled");

    if (step >= totalSteps) {
      skipButton.classList.add("disabled");
    } else {
      skipButton.classList.add("filled");
    }
  }

  function changeStep(newStep) {
    updateUI(newStep);
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { current_step: newStep.toString() } })
    }).catch(error => console.error("Error updating step:", error));
  }

  function fetchCurrentStep() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        let currentStep = cart.attributes?.current_step ? parseInt(cart.attributes.current_step) : 0;
        updateUI(currentStep);
      })
      .catch(error => console.error("Error fetching cart:", error));
  }

  function resetProgressToStart() {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { current_step: "0" } })
    })
      .then(() => fetch('/cart.js'))
      .then(response => response.json())
      .then(cart => {
        const currentStep = parseInt(cart.attributes?.current_step || "0");
        updateUI(currentStep);
      })
      .catch(error => console.error("Error resetting progress:", error));
  }

  resetProgressToStart().then(() => {
    document.dispatchEvent(new CustomEvent("cartStepReady"));
  });

  if (skipButton) {
    skipButton.addEventListener("click", function () {
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          var currentStep = cart.attributes?.current_step ? parseInt(cart.attributes.current_step) : 0;
          if (currentStep < totalSteps) {
            changeStep(currentStep + 1);
          }
        });
    });
  }

  if (goBackButton) {
    goBackButton.addEventListener("click", function () {
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          var currentStep = cart.attributes?.current_step ? parseInt(cart.attributes.current_step) : 0;
          if (currentStep > 0) {
            changeStep(currentStep - 1);
          }
        });
    });
  }

  function checkCartAndHideSections() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        if (cart.item_count === 0) {
          if (progressBar) progressBar.style.display = "none";
          sections.forEach(section => { if (section) section.style.display = "none"; });
        }
      })
      .catch(error => console.error("Error fetching cart:", error));
  }

  checkCartAndHideSections();

  document.body.addEventListener("click", function (event) {
    if (event.target.classList.contains("add-to-cart") || event.target.classList.contains("cart-remove")) {
      setTimeout(checkCartAndHideSections, 500);
    }
  });
});
